export const TYPE_LOCAL_BUSINESS = {
  "cham-soc-da-massage": "DaySpa",
  "lam-toc-mong": "HairSalon",
  "tham-my-vien": "BeautySalon",
  "phong-kham": "HealthClub",
  "the-duc-the-thao": "HealthClub",
  "xam-hinh": "TattooParlor",
};
import gs from "gstyles";

const CATEGORY_SIZE = 52;
export const CATEGORIES = [
  {
    icon: gs.icons({ name: "category-salon", size: CATEGORY_SIZE }),
    iconName: "category-salon",
    code: "M1",
    name: "Salon mi và móng",
    nameKey: "category.nailLash",
  },
  {
    icon: gs.icons({ name: "category-spa", size: CATEGORY_SIZE }),
    iconName: "category-spa",
    code: "M2",
    name: "Spa chăm da",
    nameKey: "category.skinCare",
  },
  {
    icon: gs.icons({ name: "category-massage", size: CATEGORY_SIZE }),
    iconName: "category-massage",
    code: "M3",
    name: "Massage gội đầu",
    nameKey: "category.massage",
  },
  {
    icon: gs.icons({ name: "category-tham-my", size: CATEGORY_SIZE }),
    iconName: "category-tham-my",
    code: "M4",
    name: "Thẩm mỹ nha khoa",
    nameKey: "category.dental",
  },
  {
    icon: gs.icons({ name: "category-toc", size: CATEGORY_SIZE }),
    iconName: "category-toc",
    code: "M5",
    name: "Salon tóc Make-up",
    nameKey: "category.hairMakeup",
  },
  {
    icon: gs.icons({ name: "category-workshop", size: CATEGORY_SIZE }),
    iconName: "category-workshop",
    code: "M6",
    name: "Workshop",
    nameKey: "category.workshop",
  },
  {
    icon: gs.icons({ name: "category-gym", size: CATEGORY_SIZE }),
    iconName: "category-gym",
    code: "05",
    name: "Gym yoga Dance",
    nameKey: "category.gym",
  },
  {
    icon: gs.icons({
      name: "category-life-coach",
      size: CATEGORY_SIZE,
    }),
    iconName: "category-life-coach",
    code: "M7",
    name: "Life coach",
    nameKey: "category.lifeCoach",
  },
];

/**
 * Tra i18n key của danh mục theo `code` (M1, M2... do CMS trả về).
 * CMS chỉ lưu tên tiếng Việt nên khi đổi ngôn ngữ phải map về key dịch.
 */
export const categoryNameKeyByCode = (code?: string): string | undefined =>
  CATEGORIES.find((cat) => cat.code === code)?.nameKey;

/** Link tải app Lookme — dùng chung cho mọi nút App Store / Google Play */
export const APP_STORE_URL =
  "https://apps.apple.com/vn/app/lookme-%C4%91%E1%BA%B7t-l%E1%BB%8Bch-l%C3%A0m-%C4%91%E1%BA%B9p/id1447215019?l=vi";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.lookme.users&hl=vi";
/** Ảnh QR tải app (public/) */
export const APP_QR_IMAGE = "/dub-qrcode.png";

/** Domain gốc của website (canonical, sitemap, OG, schema.org) */
/**
 * Công tắc tính năng "Gói tiết kiệm" (prepaidPackage — ưu đãi gói trả trước).
 * App chưa triển khai mua gói → mặc định TẮT: ẩn dải trang chủ, tab/menu, trang /goi-tiet-kiem (404), sitemap.
 * Khi app mở bán gói: đổi thành true → build + deploy.
 * (Không tắt qua CMS được vì app TestFlight dùng chung section home-package-promotion — code chặn cả dải trang chủ.)
 */
export const FEATURE_PREPAID_PACKAGE = false;

/** Domain công khai — mặc định đặt 1 chỗ ở next.config.ts (env.NEXT_PUBLIC_APP_URL), không lặp fallback ở đây. */
export const SITE_URL = (process.env.NEXT_PUBLIC_APP_URL || "").replace(/\/$/, "");
